<template>
  <div
    id="horizontal-navigation-hover-normal"
    class="d-lg-block mt-2 mt-lg-0"
  >
    <ul class="nav-main nav-main-horizontal nav-main-hover">
      <!-- Expert items -->
      <li class="nav-main-item">
        <a
          class="nav-main-link nav-main-link-submenu"
          data-toggle="submenu"
          aria-haspopup="true"
          aria-expanded="false"
          href="#"
        >
          <i class="nav-main-link-icon fa fa-users" />
          <span class="nav-main-link-name">Expert</span>
        </a>
        <ul class="nav-main-submenu">
          <li class="nav-main-item">
            <form
              ref="expertAssignmentInviteEmailForm"
              method="get"
              action="/admin/email/expert-assignment-invite/generate"
              class="expert-assignment-invite-mail"
              name="expertAssignmentInviteEmailForm"
            >
              <input
                type="hidden"
                name="_token"
                :value="csrf"
              >
              <input
                type="hidden"
                name="selectedExpertIds"
                :value="selectedExpertIdsComputed"
              >
              <input
                type="hidden"
                name="projectId"
                :value="project.id"
              >
              <input
                type="hidden"
                name="emailType"
                :value="emailType"
              >
            </form>
            <a
              v-if="routes['backend_dummy_expert_send_invitation_email']"
              id="expertAssignmentInviteInvitationLegacy"
              class="nav-main-link"
              href="#"
              @click.stop.prevent="expertAssignmentInviteInvitation('invite')"
            >
              <span class="nav-main-link-name">Send Invitation Email</span>
            </a>
            <a
              v-if="routes['backend_dummy_expert_send_lead_email']"
              id="expertAssignmentInviteLeadLegacy"
              class="nav-main-link"
              href=""
              @click.stop.prevent="expertAssignmentInviteInvitation('lead')"
            >
              <span class="nav-main-link-name">Send Lead Email</span>
            </a>
          </li>
          <li class="nav-main-item">
            <a
              class="nav-main-link"
              href=""
              @click.stop.prevent="deleteManyAssignments"
            >
              <span class="nav-main-link-name"> Remove Selected Experts </span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Client items -->
      <li
        v-show="routes['backend_dummy_client_send_proposal_email']"
        class="nav-main-item"
      >
        <a
          class="nav-main-link nav-main-link-submenu"
          data-toggle="submenu"
          aria-haspopup="true"
          aria-expanded="false"
          href="#"
        >
          <i class="nav-main-link-icon far fa-user-circle" />
          <span class="nav-main-link-name">Client</span>
        </a>
        <ul class="nav-main-submenu">
          <li class="nav-main-item">
            <form
              ref="clientProposalGenerateEmailForm"
              method="get"
              action="/admin/email/client-proposal/generate"
              class="expert-assignment-invite-mail"
              name="clientProposalGenerateEmailForm"
            >
              <input
                type="hidden"
                name="_token"
                :value="csrf"
              >
              <input
                type="hidden"
                name="selectedExpertIds"
                :value="selectedExpertIdsComputed"
              >
              <input
                type="hidden"
                name="selectedJobExpIds"
                :value="selectedJobExpIdsComputed"
              >
              <input
                type="hidden"
                name="projectId"
                :value="project.id"
              >
            </form>
            <a
              id="clientProposalGenerateEmailAnchorLegacy"
              class="nav-main-link"
              href="#"
              @click.stop.prevent="clientProposalGenerateEmailAnchor"
            >
              <span class="nav-main-link-name">Send Proposal Email</span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Clone Project items -->
      <li
        v-if="routes['backend_project_edit']"
        class="nav-main-item"
      >
        <a
          class="nav-main-link nav-main-link-submenu"
          data-toggle="submenu"
          aria-haspopup="true"
          aria-expanded="false"
          href="#"
        >
          <i class="nav-main-link-icon far fa-clone" />
          <span class="nav-main-link-name">Clone Project</span>
        </a>
        <ul class="nav-main-submenu">
          <li class="nav-main-item">
            <a
              class="nav-main-link"
              :href="getCloneProjectUrl(project.id, false)"
            >Clone Project</a>
            <a
              class="nav-main-link"
              :href="getCloneProjectUrl(project.id, true)"
              @click.stop.prevent="checkExpertChecked"
            >Clone project with checked experts</a>
          </li>
        </ul>
      </li>

      <li class="my-auto mx-2 pt-1">
        <div class="custom-control custom-checkbox custom-control-lg mb-1 display-option">
          <input
            id="hideJobExperiences"
            type="checkbox"
            class="custom-control-input"
            @change.stop.prevent="$store.commit('expert/setHideJobExperiencesComputed', $event.target.checked)"
          >

          <label
            class="custom-control-label"
            for="hideJobExperiences"
          >{{
            $store.state.expert.hideJobExperiencesComputed
              ? "Show job experiences"
              : "Hide job experiences"
          }}</label>
        </div>
      </li>

      <li class="my-auto mx-2 pt-1">
        <div class="custom-control custom-checkbox custom-control-lg mb-1 display-option">
          <input
            id="selectAllExperts"
            type="checkbox"
            class="custom-control-input"
            :checked="selectAllExperts"
            @change.stop.prevent="$store.commit('expert/setSelectAllExperts', $event.target.checked)"
          >
          <label
            class="custom-control-label"
            for="selectAllExperts"
          >{{
            $store.state.expert.selectAllExperts
              ? "Deselect all experts"
              : "Select all experts"
          }}</label>
        </div>
      </li>

      <li class="my-auto mx-3 pt-1">
        <b-dropdown
          split
          :text="assignmentStatusFilterSelected ? assignmentStatusFilterSelected.name : 'Sort experts by status'"
          :variant="assignmentStatusFilterSelected && statusStyles[assignmentStatusFilterSelected.name] ? statusStyles[assignmentStatusFilterSelected.name] : 'secondary'"
          size="sm"
        >
          <b-dropdown-item-button @click.stop.prevent="filterExpertByStatus(null)">
            Sort experts by status
          </b-dropdown-item-button>

          <b-dropdown-item-button
            v-for="(status, ib) in allAssignmentStatuses"
            :key="`filter${ib}`"
            @click.stop.prevent="filterExpertByStatus(status)"
          >
            {{ status.name }} ({{ status.count }})
          </b-dropdown-item-button>
        </b-dropdown>

        <b-spinner
          v-if="loader"
          variant="primary"
          small
          label="Loading..."
        />
      </li>

      <li class="my-auto mx-3 pt-1">
        <div class="custom-control custom-checkbox custom-control-lg mb-1 display-option">
          <button
            class="btn btn-sm btn-success"
            @click.stop.prevent="toggleAll"
          >
            {{
              $store.state.expert.showAll
                ? "Show Paginated"
                : "Show All"
            }}
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { isEmpty } from "lodash";

export default {
    name: "ProjectNavBar",
    props: {
        projectInit: {
            type: String,
            required: true,
        },
        allAssignmentStatusesInit: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            csrf: "",
            projectRaw: {},
            emailType: "",
            allAssignmentStatuses: [],
            loader: false,
        };
    },
    computed: {
        project() {
            return this.projectRaw || {};
        },
        routes() {
            return this.$store.state.routes.routePermissions || [];
        },
        selectedExpertIdsComputed() {
            return this.$store.state.expert.selectedExpertIds.join(",");
        },
        selectedJobExpIdsComputed() {
            return this.$store.state.expert.selectedJobExpIds.join(",");
        },
        ...mapGetters({
            selectAllExperts: "expert/selectAllExperts",
            assignmentStatusFilterSelected: "expert/assignmentStatusFilterSelected",
            statusStyles: "project/statusStyles",
            selectedExpertIds: "expert/selectedExpertIds",
        }),
    },
    mounted() {
        this.projectRaw = this.projectInit ? JSON.parse(this.projectInit) : null;
        const token = document.head.querySelector("meta[name=\"csrf-token\"]");
        this.csrf = token.content;
        this.allAssignmentStatuses = this.allAssignmentStatusesInit.length > 0
            ? JSON.parse(this.allAssignmentStatusesInit)
            : [];
    },
    methods: {
        async deleteManyAssignments() {
            if (this.selectedExpertIdsComputed.length === 0) {
                alert("You have not selected any experts");
                return;
            }

            if (!confirm("Are you sure you want to remove these experts from the project?")) {
                return;
            }
            const selectedAssignmentIds = [];
            this.$store.state.expert.selectedExpertIds.forEach((sid) => {
                this.$store.state.expert.usersExpertsObj.data.forEach((user) => {
                    if (Number(user.expert.id) === Number(sid)) {
                        user.expert.assignments.forEach((assignment) => {
                            if (Number(assignment.project_id) === Number(this.project.id)) {
                                selectedAssignmentIds.push(assignment.id);
                            }
                        });
                    }
                });
            });
            const url = "/admin/assignment/deleteMany";
            try {
                const responce = await axios.post(url, {
                    selectedAssignmentIds: selectedAssignmentIds.join(","),
                });
                if (responce.data.errorAssignmentIds.length > 0) {
                    One.helpers(
                        "jq-notify",
                        {
                            type: "danger",
                            icon: "fa fa-times me-1",
                            message: `${responce.data.errorAssignmentIds.length} expert(s) could not be removed from this project. Please check their calendar, as they may have scheduled appointments. Or have payment requested`,
                        });
                }
                this.$store.commit("expert/setSelectedExpertIds", []);
                this.$store.commit("expert/setSelectedJobExpIds", []);

                await this.$store.dispatch("expert/getProjectExperts", { projectId: this.project.id, page: 1 });
            } catch (e) {
                One.helpers(
                    "jq-notify",
                    {
                        type: "danger",
                        icon: "fa fa-times me-1",
                        message: "An unknown error has occurred",
                    });
            }
        },
        checkExpertChecked(event) {
            if (this.selectedExpertIdsComputed.length === 0) {
                alert("You have not selected any experts");
                return;
            }

            window.location.href = event.target.href;
        },
        clientProposalGenerateEmailAnchor() {
            if (this.selectedExpertIdsComputed.length === 0) {
                alert("You have not selected any experts");
                return;
            }
            if (this.selectedJobExpIdsComputed.length === 0) {
                alert("You have not selected any job experience");
                return;
            }
            setTimeout(() => {
                this.$refs.clientProposalGenerateEmailForm.submit();
            }, 50);
        },
        expertAssignmentInviteInvitation(emailType) {
            if (this.selectedExpertIdsComputed.length === 0) {
                alert("Please select at least one expert");
                return;
            }
            this.emailType = emailType;
            setTimeout(() => {
                this.$refs.expertAssignmentInviteEmailForm.submit();
            }, 50);
        },
        toggleAll() {
            this.loader = true;
            const state = !this.$store.state.expert.showAll;
            this.$store.commit("expert/setShowAll", state);
            this.$store.dispatch("expert/getProjectExperts", { projectId: this.project.id, page: 1 })
                .then(() => {
                    this.loader = false;
                });
        },
        filterExpertByStatus(status) {
            this.loader = true;

            this.$store.commit("expert/setSelectAllExperts", false);
            this.$store.commit("expert/setAssignmentStatusFilterSelected", status);
            this.$store.dispatch("expert/getProjectExperts", { projectId: this.project.id }).then(() => {
                this.loader = false;
            });
        },
        getCloneProjectUrl(projectId, includeExpert = false) {
            const selectedIds = this.selectedExpertIds;
            const url = new URL(`/admin/project/clone/${projectId}`, window.location.origin);

            if (includeExpert && !isEmpty(selectedIds)) {
                url.searchParams.append("selectedCloneIds", this.selectedExpertIdsComputed);
                url.searchParams.append("selectedJobExpIds", this.selectedJobExpIdsComputed);
            }

            return url;
        },
    },
};
</script>
